export default function SearchBar({ children }) {
    return (
        <div style={{ position: 'fixed', top:'3.5rem', width: '100%', backgroundColor: '#22264b', color: 'white', padding: '0.5rem 3rem 0.5rem 3rem' }}>
            {children}
        </div>
    );
}